export default __webpack_public_path__ + "static/media/fire-house-icon.b32603a6.svg";